import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
    showBanner = false;
    showDetails = false;

    ngOnInit(): void {
        // Check if user has already made a choice
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
            // Show banner after a short delay for better UX
            setTimeout(() => {
                this.showBanner = true;
            }, 1000);
        }
    }

    acceptAll(): void {
        localStorage.setItem('cookieConsent', 'all');
        this.showBanner = false;
    }

    acceptNecessary(): void {
        localStorage.setItem('cookieConsent', 'necessary');
        this.showBanner = false;
    }

    toggleDetails(): void {
        this.showDetails = !this.showDetails;
    }
}
